import React, { useState } from 'react'
// import _ from 'lodash'
import TextGroup, { Image, WorkGroup } from './Texts'
import { Desktop, Mobile } from './MediaQueries';
import arrow_dark from '../assets/images/arrow-small-dark.svg';
import arrow_white from '../assets/images/arrow-small-white.svg';

export const ServiceBlock = props => {

  if (props.image.rootProps) {
    if (props.rev) {
      props.image.rootProps.className += ' image-margin-left'
    } else {
      props.image.rootProps.className += ' image-margin-right'
    }
  }

  const [expand, setExpand] = useState(true);

  return (
    <div {...props.rootProps}>
      <Desktop>
        {props.rev ? (
          <React.Fragment>
            <Image {...props.image} />
            <TextGroup {...props.textGroup}>
              <div className="image">
                <img src={props.textLeadImage} alt="" />
              </div>
            </TextGroup>
            {props.children}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <TextGroup {...props.textGroup}>
              <div className="image">
                <img src={props.textLeadImage} alt="" />
              </div>
            </TextGroup>
            <Image {...props.image} />
            {props.children}
          </React.Fragment>
        )}
      </Desktop>
      <Mobile>
        <div className="service--mobile">
          <Image {...props.image} {...{ rootProps: { className: "mobile-background" } }} />
          <TextGroup title={props.textGroup.title} rootProps={{ className: 'overlay-wrapper' }} >
            <div className="image">
              <img src={props.textLeadImage} alt="" />
            </div>
            <a href="#" onClick={(e) => { e.preventDefault(); setExpand(!expand) }}>
              {expand ? (<>{props.texts.more} <Image image={arrow_dark} width={9} height={9} /></>) : (<>{props.texts.less} <Image rootProps={{ style: { transform: 'scaleY(-1)' } }} image={arrow_dark} width={9} height={9} /></>)}
            </a>
          </TextGroup>
        </div>

        <TextGroup
          rootProps={{
            style: {
              overflow: 'hidden',
              zIndex: !expand ? '100' : '-1',
              height: 'auto',
              transition: !expand ? "all .3s ease-in" : "all .3s ease-out",
              maxHeight: !expand ? '5000px' : '0px',
              opacity: !expand ? "1" : "0",
              padding: !expand ? '2em' : '0em',
              width: '100%',
            }
          }}
          description={props.textGroup.description}
          cta={props.textGroup.cta}
          childrenAfter={true}
        >
          {props.children}
        </TextGroup>
      </Mobile>
    </div >
  )
}


export const WorkBlock = props => {
  const [expand, setExpand] = useState(true);

  if (props.image.rootProps) {
    if (props.rev) {
      props.image.rootProps.className += ' image-margin-left'
    } else {
      props.image.rootProps.className += ' image-margin-right'
    }
  }

  return (
    <div {...props.rootProps}>
      <Desktop>
        {props.rev ? (
          <React.Fragment>
            <Image {...props.image} />
            <WorkGroup {...props.workGroup} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <WorkGroup {...props.workGroup} />
            <Image {...props.image} />
          </React.Fragment>
        )}
      </Desktop>
      <Mobile>
        <div className="work-entry--mobile">
          <Image {...props.image} {...{ rootProps: { className: "mobile-background" } }} />
          <TextGroup title={props.workGroup.title} rootProps={{ className: 'overlay-wrapper' }} >
            <a href="#" onClick={(e) => { e.preventDefault(); setExpand(!expand) }}>
              {expand ? (<>{props.texts.more} <Image image={arrow_white} width={9} height={9} /></>) : (<>{props.texts.less} <Image rootProps={{ style: { transform: 'scaleY(-1)' } }} image={arrow_white} width={9} height={9} /></>)}
            </a>
          </TextGroup>
        </div>
        <WorkGroup
          rootProps={{
            style: {
              height: 'auto',
              transition: !expand ? "all .5s ease-in" : "all .5s ease-out",
              maxHeight: !expand ? '5000px' : '0px',
              opacity: !expand ? "1" : "0",
              padding: !expand ? '2em' : '0em',
            }
          }} workTypes={props.workGroup.workTypes} description={props.workGroup.description}
        />
      </Mobile>
    </div>
  )
}

export const AboutBlock = props => {

  if (props.image.rootProps) {
    if (props.rev) {
      props.image.rootProps.className += ' image-margin-left'
    } else {
      props.image.rootProps.className += ' image-margin-right'
    }
  }

  return (
    <div {...props.rootProps}>
      <Desktop>
        {props.rev ? (
          <React.Fragment>
            {props.image && <Image {...props.image} />}
            {props.textGroup && <TextGroup {...props.textGroup} />}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {props.textGroup && <TextGroup {...props.textGroup} />}
            {props.image && <Image {...props.image} />}
          </React.Fragment>
        )}
      </Desktop>
      <Mobile>
        {props.image && <Image {...props.image} />}
        {props.textGroup && <TextGroup {...props.textGroup} />}
      </Mobile>
    </div>
  )
}

export default ServiceBlock
